// src/components/Admin/tabs/BookingsTab.jsx
import React, { useState } from 'react';
import BookingsCalendar from '../BookingsCalendar';
import AdminErrorBoundary from '../AdminErrorBoundary';
import DailyGuestsTable from './DailyGuestsTable';
import { money } from '../adminUtils';
import { formatMXDate } from '../../../utils/dates';

const BookingsTab = ({ bookings, onStatusChange }) => {
  const [selectedBooking, setSelectedBooking] = useState(null);

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl border border-[#3A2A20]/10 p-4">
        <AdminErrorBoundary label="El calendario de reservas">
          <BookingsCalendar bookings={bookings} onSelectBooking={setSelectedBooking} />
        </AdminErrorBoundary>
      </div>

      <DailyGuestsTable bookings={bookings} />

      {selectedBooking && (
        <div className="p-6 bg-white border border-[#3A2A20]/10 rounded-2xl">
          <h3 className="font-['Fraunces'] text-lg font-semibold text-[#3A2A20] mb-4">
            Detalles de la reserva
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-[#3A2A20]">
            <div className="space-y-1.5">
              <p><strong>Usuario:</strong> {selectedBooking.user?.fullname} ({selectedBooking.user?.email})</p>
              <p><strong>Cuarto:</strong> {selectedBooking.room?.name} (#{selectedBooking.room?.roomNumber})</p>
              <p><strong>Check-in:</strong> {formatMXDate(selectedBooking.checkInDate)}</p>
              <p><strong>Check-out:</strong> {formatMXDate(selectedBooking.checkOutDate)}</p>
            </div>
            <div className="space-y-1.5">
              <p><strong>Precio total:</strong> {money(selectedBooking.totalPrice)}</p>
              <p className="flex items-center gap-2">
                <strong>Status:</strong>
                <select
                  value={selectedBooking.status}
                  onChange={(e) => {
                    onStatusChange(selectedBooking._id, e.target.value);
                    setSelectedBooking({ ...selectedBooking, status: e.target.value });
                  }}
                  className="border border-[#3A2A20]/15 rounded-lg p-1.5 text-sm"
                >
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="checked-in">Checked In</option>
                  <option value="checked-out">Checked Out</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </p>
              <p><strong>Peticiones especiales:</strong> {selectedBooking.specialRequests || 'Ninguna'}</p>
            </div>
          </div>
          <div className="mt-4 text-right">
            <button
              onClick={() => setSelectedBooking(null)}
              className="px-4 py-2 text-sm font-medium text-[#3A2A20] border border-[#3A2A20]/20 rounded-lg hover:bg-[#3A2A20]/5 transition"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingsTab;